/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import {AppService} from 'app/app.service';


@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router, private loginService: LoginService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
          const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser != null && currentUser.token != null) {
              const req = request.clone({
                setHeaders: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${currentUser.token}`
                }
              });
              return next.handle(req);
            }
        return next.handle(request);
    }

}